import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "24",
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.14286 19.6514H2.71429C2.25963 19.6514 1.82359 19.4708 1.5021 19.1493C1.18061 18.8278 1 18.3918 1 17.9371V11.08C1 10.6253 1.18061 10.1893 1.5021 9.86782C1.82359 9.54633 2.25963 9.36571 2.71429 9.36571H23.2857C23.7404 9.36571 24.1764 9.54633 24.4979 9.86782C24.8194 10.1893 25 10.6253 25 11.08V17.9371C25 18.3918 24.8194 18.8278 24.4979 19.1493C24.1764 19.4708 23.7404 19.6514 23.2857 19.6514H19.8571M6.14286 9.36571V2.71429C6.14286 2.25963 6.32347 1.82359 6.64496 1.5021C6.96645 1.18061 7.40249 1 7.85714 1H13H18.1429C18.5975 1 19.0335 1.18061 19.355 1.5021C19.6765 1.82359 19.8571 2.25963 19.8571 2.71429V9.36571M6.14286 16.2229H19.8571V23.08H6.14286V16.2229Z",
      stroke: "#AA1E2D",
      "stroke-width": "1.67"
    }, null, -1)
  ])))
}
export default { render: render }